import { EmdrBoardAPI } from "../infrastructure/api/EmdrBoard.api";

/** The patient's way onto a shared board, from its link: where to start reading. */
export async function joinPublicBoard(token: string): Promise<{ cursor: number }> {
    const { data } = await EmdrBoardAPI.join(token);
    return data;
}
